<template>

  <q-page class="flex-center">
    <div class="q-pa-md">
      <q-card-section>
        <q-tabs
          v-model="tab"
          dense
          class="text-grey"
          active-color="primary"
          indicator-color="primary"
          align="justify"
          narrow-indicator
        >
          <q-tab name="basic" label="Dados básicos"></q-tab>
          <q-tab name="payment_form" label="Dados de pagamento" :disable="two" ref="payment_form"></q-tab>
          <q-tab name="address" label="Endereço" ref="address" :disable="three"></q-tab>
        </q-tabs>

        <q-separator></q-separator>

        <q-tab-panels v-model="tab" animated>
          <q-tab-panel name="basic">
            <div class="q-pa-md">
              <div class="row q-col-gutter-xs">
                <q-form class="col-12" @submit.prevent.stop="stepTwo">
                  <div class="row q-col-gutter-xs">
                    <div class="col-4">
                      <q-input outlined v-model="donator.name" label="Primeiro nome"
                               :rules="[value => !!value  || 'Campo obrigatório']"/>
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.last_name" label="Sobrenome"
                               :rules="[value => !!value || 'Campo obrigatório']"/>
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.email" label="E-mail"
                               :rules="[ email => emailPattern.test(email) || 'Necessário um e-mail válido']"/>
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.document" label="Documento" mask="###.###.###-##"
                               unmasked-value
                               :rules="[value => !!value  || 'Campo obrigatório']"/>
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.tel_res" label="Telefone residencial" mask="(##) ####-####"
                              />
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.tel_cel" mask="(##) # ####-####" label="Telefone celular"
                               :rules="[value => !!value  || 'Campo obrigatório']"/>
                    </div>

                    <div class="col-4">
                      <q-select bg-color="primary"
                                outlined
                                v-model="donator.donator_status_id"
                                :rules="[value => !!value  || 'Campo obrigatório']"
                                options-dense
                                map-options
                                :display-value="'Status do doador'"
                                :options="statusDoadorOptions"
                                option-value="id"
                                option-label="name"
                                emit-value
                                style="min-width: 150px"
                      />
                    </div>

                    <div class="col-4">
                      <q-select bg-color="primary"
                                outlined
                                v-model="donator.shipping_method_id"
                                options-dense
                                map-options
                                :display-value="'Forma de Envio'"
                                :options="formaEnvioOptions"
                                option-value="id"
                                option-label="name"
                                emit-value
                                style="min-width: 150px"
                      />
                    </div>
                    <div class="col-4">
                      <q-select bg-color="primary"
                                outlined
                                v-model="donator.donator_type_id"
                                :rules="[value => !!value  || 'Campo obrigatório']"
                                options-dense
                                map-options
                                :display-value="'Tipo do doador'"
                                :options="tipoDoadorOptions"
                                option-value="id"
                                option-label="name"
                                emit-value
                                style="min-width: 150px"
                      />

                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.birthday" label="Data de nascimento" mask="##/##/####"
                               :rules="[value => !!value  || 'Campo obrigatório']"/>
                    </div>
                    <div class="col-4">
                      <q-radio v-model="donator.sex" val="M" label="Masculino"/>
                      <q-radio v-model="donator.sex" val="F" label="Feminino"/>
                    </div>
                    <!--<div class="col-4">
                      <q-radio v-model="donator.person_type" val="1" label="Pessoa jurídica"/>
                      <q-radio v-model="donator.person_type" val="2" label="Pessoa física"/>
                    </div>-->
                  </div>
                  <br>
                  <q-btn label="Prosseguir" type="submit" color="primary"/>
                </q-form>
              </div>
            </div>

          </q-tab-panel>

          <q-tab-panel name="payment_form">
            <div class="text-h6"></div>
            <div class="q-pa-md">
              <div class="row q-col-gutter-xs">
                <q-form class="col-12" @submit.prevent.stop="stepThree">
                  <div class="row q-col-gutter-xs">
                    <div class="col-4">
                      <q-select bg-color="primary"
                                outlined
                                v-model="donator.payment_form_id"

                                options-dense
                                map-options

                                :display-value="'Forma de Pagamento'"
                                :options="formaPagamentoOptions"
                                option-value="id"
                                option-label="name"
                                emit-value
                                style="min-width: 150px"
                      />
                    </div>
                    <div class="col-4">
                      <q-select bg-color="primary"
                                outlined
                                v-model="donator.bank"

                                options-dense
                                map-options

                                :display-value="'Banco'"
                                :options="bankOptions"
                                option-value="id"
                                option-label="name"
                                emit-value
                                style="min-width: 150px"
                      />
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.maturity_day" unmasked-value
                               label="Dia de recorrência"/>
                    </div>

                    <div class="col-4">
                      <q-input outlined v-model="donator.agency"
                               label="Agência bancária" mask="####"/>
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.bank_account"
                               label="Conta bancária"/>
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.recurrence_value" unmasked-value
                               mask="R$ ######.###,##"
                               label="Valor"/>
                    </div>

                    <div class="col-4">
                      <q-input outlined v-model="donator.card_number"
                               label="Número do cartão" mask="####.####.####.####"/>
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.card_maturity" mask="##/##"
                               label="Vencimento do cartão"/>
                    </div>
                  </div>
                  <br>

                  <q-btn label="Prosseguir" type="submit" color="primary"/>
                </q-form>
              </div>

            </div>
          </q-tab-panel>

          <q-tab-panel name="address">
            <div class="q-pa-md">
              <div class="row q-col-gutter-xs">
                <q-form class="col-12" @submit.prevent.stop="final">
                  <div class="row q-col-gutter-xs">
                    <div class="col-4">
                      <q-input outlined v-model="donator.zipcode" label="CEP" @blur="onZipCode" mask="#####-###"
                               :rules="[value => !!value || 'Campo obrigatório']"/>
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.street" label="Logradouro"
                               :rules="[value => !!value || 'Campo obrigatório']"/>
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.number" label="Número"
                               :rules="[value => !!value || 'Campo obrigatório']"/>
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.complement" label="Complemento"
                      />
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.neighborhood" label="Bairro"
                               :rules="[value => !!value || 'Campo obrigatório']"/>
                    </div>

                    <div class="col-4">
                      <q-input outlined v-model="donator.city" label="Cidade"
                               :rules="[value => !!value || 'Campo obrigatório']"/>
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.state" label="Estado"
                               :rules="[value => !!value || 'Campo obrigatório']"/>
                    </div>
                  </div>
                  <br>
                  <q-btn label="Salvar" type="submit" color="primary"/>
                </q-form>
              </div>
            </div>
          </q-tab-panel>
        </q-tab-panels>
      </q-card-section>
    </div>
    <q-dialog v-model="created">
      <q-card>
        <q-card-section>
          <div class="text-h6">Sucesso!</div>
        </q-card-section>

        <q-card-section>
          O doador foi salvo com sucesso!
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="OK" color="primary" v-close-popup @click="retorna"/>
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog v-model="document">
      <q-card>
        <q-card-section>
          <div class="text-h6">Erro!</div>
        </q-card-section>

        <q-card-section>
          Este documento já está na base de dados!
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="OK" color="primary" @click="document = false"/>
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog v-model="email">
      <q-card>
        <q-card-section>
          <div class="text-h6">Erro!</div>
        </q-card-section>

        <q-card-section>
          Este e-mail já está na base de dados!
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="OK" color="primary" @click="email = false"/>
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-inner-loading :showing="loading">
      <q-spinner-dots size="50px" color="primary"/>
    </q-inner-loading>
  </q-page>
</template>

<script>
import { DONATOR, DONATOR_BY_CPF, DONATOR_BY_EMAIL, REGISTER_DONATOR, UPDATE_DONATOR } from '../graphql/graphql'

export default {
  name: 'DoadorEdit',
  props: {
    id: {
      type: String
    }
  },
  apollo: {
    UpdateDonatorSite: {
      query: UPDATE_DONATOR,
      variables () {
        return {
          donator: this.donator
        }
      },
      skip: true
      // pollInterval: 300, // ms
    },
    donatorByEmail: {
      query: DONATOR_BY_EMAIL,
      variables () {
        return {
          email: this.donator.email
        }
      },
      skip: true
      // pollInterval: 300, // ms
    },
    donatorByCPF: {
      query: DONATOR_BY_CPF,
      variables () {
        return {
          cpf: this.donator.document
        }
      },
      skip: true
      // pollInterval: 300, // ms
    },
    donator: {
      query: DONATOR,
      variables () {
        return {
          id: this.id
        }
      },
      skip: true
      // pollInterval: 300, // ms
    }
  },
  data () {
    return {
      document: false,
      email: false,
      tab: 'basic',
      loading: true,
      created: false,
      two: true,
      three: true,
      donator: {
        id: '',
        sex: '',
        neighborhood: '',
        complement: '',
        city: '',
        state: '',
        street: '',
        country: 'BR',
        document: '',
        email: '',
        last_name: '',
        street: '',
        number: '',
        complement: '',
        neighborhood: '',
        city: '',
        birthday: '',
        state: '',
        zipcode: '',
        tel_res: '',
        tel_cel: '',
        sex: '',
        bank: '',
        informative: 1,
        card_matutiry: ''
      },
      loading: true,
      dense: false,
      formaPagamentoOptions: [
        { id: 1, name: 'Boleto' },
        { id: 9, name: 'Cartão de crédito' },
        { id: 11, name: 'Débito automático' },
        { id: 12, name: 'PayPal' },
        { id: 13, name: 'Transferência Identificada' },
        { id: 14, name: 'Transferência sem relacionamento' },
        { id: 15, name: 'Pólen' },
        { id: 16, name: 'Presente solidário' }
      ],
      statusDoadorOptions: [
        { id: 1, name: 'Ativo' },
        { id: 4, name: 'Atraso 1' },
        { id: 2, name: 'Atraso 2' },
        { id: 9, name: 'Inativo' },
        { id: 13, name: 'Cancelado' }
      ],
      formaEnvioOptions: [
        { id: 1, name: 'Correio' },
        { id: 2, name: 'E-mail' }
      ],
      bankOptions: [
        { id: 341, name: 'Itaú' },
        { id: '033', name: 'Santander' }
      ],
      tipoDoadorOptions: [
        { id: 1, name: 'Regular' },
        { id: 2, name: 'Único' },
        { id: 3, name: 'Ocasional' }
      ],
      donatorByEmail: {},
      donatorByCPF: {},
      emailPattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    }
  },
  methods: {
    retorna () {
      this.created = false
      this.$router.push({ name: 'doadores' })
    },
    close () {
      this.$emit('closeDonator')
    },
    formatDate (date) {
      return DateTime.fromSQL(date, {
        locale:
                        'pt-br'
      }).toLocaleString()
    },
    stepTwo (data) {
      this.two = false
      this.tab = 'payment_form'
    },
    stepThree (data) {
      this.three = false
      this.tab = 'address'
    },
    donatorByEmailBlur () {
      this.$apollo.addSmartQuery('donatorByEmail', {
        query: DONATOR_BY_EMAIL,
        variables () {
          return {
            'email': this.donator.email
          }
        },
        // pollInterval: 300,
        update (store, data) {
          if (store.donatorByEmail.length > 0) {
            this.email = true
            this.donator.email = ''
          }
        }
      })
    },
    donatorByCPFBlur () {
      this.$apollo.addSmartQuery('donatorByCPF', {
        query: DONATOR_BY_CPF,
        variables () {
          return {
            'cpf': this.donator.document
          }
        },
        // pollInterval: 300,
        update (store, data) {
          if (store.donatorByCPF.length > 0) {
            this.document = true
            this.donator.document = ''
          }
        }
      })
    },
    final () {
      this.donator.country = 'BR'
      console.log(this.donator.country)
      this.$apollo.mutate({
        mutation: UPDATE_DONATOR,
        variables: {
          id: this.id,
          name: this.donator.name,
          document: this.donator.document,
          email: this.donator.email,
          last_name: this.donator.last_name,
          street: this.donator.street,
          number: this.donator.number,
          complement: this.donator.complement,
          neighborhood: this.donator.neighborhood,
          person_type: this.donator.person_type,
          city: this.donator.city,
          birthday: this.donator.birthday,
          state: this.donator.state,
          zipcode: this.donator.zipcode,
          tel_res: this.donator.tel_res,
          tel_com: this.donator.tel_com,
          country: this.donator.country,
          tel_cel: this.donator.tel_cel,
          sex: this.donator.sex,
          informative: this.donator.informative,
          recurrence_value: this.donator.recurrence_value,
          maturity_day: this.donator.maturity_day,
          donator_status_id: this.donator.donator_status_id,
          shipping_method_id: this.donator.shipping_method_id,
          donator_type_id: this.donator.donator_type_id,
          payment_form_id: this.donator.payment_form_id,
          bank: this.donator.bank,
          bank_account: this.donator.bank_account,
          agency: this.donator.agency,
          card_number: this.donator.card_number,
          card_matutiry: this.donator.card_matutiry
        },
        update: (store, data) => {
          this.created = true
        }
      })
        .catch(error => {
          const errors = { error }
          console.log(error)
          console.log(errors)
        })
    },
    onZipCode () {
      const cep = this.donator.zipcode.replace('.', '').replace('-', '')
      fetch(`//viacep.com.br/ws/${cep}/json/`).then(res => res.json()).then(res => {
        this.donator.neighborhood = res.bairro
        this.donator.complement = res.complemento
        this.donator.city = res.localidade
        this.donator.state = res.uf
        this.donator.street = res.logradouro
        // console.log(res)
      })
    }
  },
  computed: {
    maskBank () {
      return this.masks[this.donator.bank]
    }
  },
  mounted () {
    console.log('mounted', this.donator.country)
    this.$apollo.queries.donator.skip = false
    this.$apollo.queries.donator.setVariables({ id: this.id })
    this.$apollo.queries.donator.refetch().then(result => {
      this.donator = result.data.donator
      this.loading = false
      this.$emit('loading', false)
    })
  }
}
</script>
